module.exports = "/_next/static/images/game-1-phone-gallery-08-27-2303-b8df4cceff1b74e4d4d1af9118b648cf.jpg";